import MsgEmitter from './msg-emitter.js';

// Default options for the plugin.
const DEFAULTS = {
  messages: {
    ad_start: {
      event: 'vast.adStart' 
    },
    ad_finish: {
      event: 'vast.adFinish'
    },
    content_start: {
      event: 'vast.contentStart'
    },
    content_end: {
      event: 'vast.contentEnd'
    },
    content_pause: {
      event: 'vast.contentPause'
    },
    content_play: {
      event: 'vast.contentPlay'
    },
    fullscreenchange: {
      event: 'fullscreenchange'
    },
    volumechange: {
      event: 'volumechange'
    },
    ready: {
      event: 'ready'
    }
  },
  prefix: 'vjs_api'
};

/**
 * The base Stat class to extend from. Sends nothing. Aggregates StatEmitter and utils methods.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatEmitter
 */

class MsgApi extends MsgEmitter {
  constructor(player, options) {
    let options_ = Object.assign({}, DEFAULTS, options);
    let ev = [];
    for (let i in options_.messages) {
       options_.messages[i].event && ev.push(options_.messages[i].event);
    }
    options_.events = ev;

    super(player, options_);
    this.messages = options_.messages;
    this.prefix = options_.prefix;
    this.events_ = {};
    this.player = player;
    this.init();
  }

  init() {
    for (let i in this.messages) {
      let ev = this.messages[i].event;
      this.events_[ev] = this.events_[ev] || [];
      this.events_[ev].push(Object.assign({type: i}, this.messages[i]));
    }

    this._bindEvents();
    this.player.on('dispose', () => {
      this._unbindEvents();
    });
    this.listen();
  }

  _bindEvents() {
    this.events.forEach((ev) => {
      this.on(ev, () => {
        this.send(ev);
      });
    });
  }

  _unbindEvents() {
    this.events.forEach((ev) => {
      this.off(ev);
    });
  }

  getMsgData({type, cmd, cmd_p, value, err} = {}) {
    let d = {type: this.prefix, event: type, player_id: this.player.id()};
    if (cmd) d.cmd = cmd;
    if (cmd_p) d.cmd_p = cmd_p;
    if (value) d.value = value;
    if (err) d.err = err;
    return d;
  }

  make(command, params = '[]') {
    let info = {type: 'cmd_cb', cmd: command && command.toString()};
    if (this.player[command]) {
      try {
        let p = JSON.parse(params), 
          val;
        p = Array.isArray(p) ? p : [p];
        val = this.player[command].apply(this.player, p);
        if (typeof val !== 'object') { // object ref will be forbidden by CORS
          info.value = val; 
        }
      } catch (err) {
        info.err = err.message;
      }
    } else {
      info.err = 'Unknown command';
    }
    window.parent.postMessage(this.getMsgData(info), '*');
  }

  send(ev) {
    this.events_[ev].forEach((info) => {
      window.parent.postMessage(this.getMsgData(info), '*');
    });
  }

  listen() {
    window.addEventListener('message', event => {
      let d = event.data || {};
      if (d.type !== this.prefix || // not an API message
        d.player_id && d.player_id != this.player.id() || // not for our player
        !d.cmd || d.event == 'cmd_cb' // prevent infinitive loop for non-iframe window
      ) return;
      this.make(d.cmd, d.cmd_p);
    });
  }
}

export default MsgApi;
